import type { DocumentItem } from '@/js/account/entities/document/model/types';
import { onMounted, ref } from 'vue';
import { accountDocumentsRecentlyViewedIndex } from '@/js/account/entities/document/api';

const DEFAULT_LIMIT = 10;

export function useRecentlyViewedDocuments(limit = DEFAULT_LIMIT) {
  const documents = ref<DocumentItem[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);

  async function fetch(): Promise<void> {
    loading.value = true;
    error.value = null;

    try {
      documents.value = await accountDocumentsRecentlyViewedIndex({ limit });
    }
    catch {
      error.value = 'Failed to load recently viewed documents.';
      documents.value = [];
    }
    finally {
      loading.value = false;
    }
  }

  onMounted(() => {
    void fetch();
  });

  return {
    documents,
    loading,
    error,
    fetch,
  };
}
